import { css } from 'styled-components';

export const clampAtLine = (lineNum: number) => css`
  /* 
  -webkit-line-clamp CSS property allows limiting of
  the contents of a block container (-webkit-box) to the
  specified number of lines, 1 means 1 line after which
  the content will be clamped.
  overflow to hidden, otherwise the contents won't be clipped
  but an ellipsis will still be shown after the
  specified number of lines.
  -webkit-box-orient: defined the box lays out its contents
  vertically.
  */
  display: -webkit-box;
  -webkit-line-clamp: ${lineNum};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
